module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "dash-color-skin cursor-pointer",
    class: 'fa ' + _vm.faStar + ' star',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleStar($event)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cd8f0a1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contactFav.vue
// module id = 3700
// module chunks = 1